import {UserStore} from "../../../data/stores/UserStore";
import {BearerTokenApi} from "./BearerTokenApi";
import {Router} from "@/rawdogjs/src/router";
import {Result} from "@/rawdogjs/src/core/Result";
import {ValidationError} from "@/rawdogjs/src/core/ValidationError";
import {UuidHelper} from "../../../shared/IdentityHelper";

export class AuthenticationManager {

    private _userStore: UserStore;
    private _bearerTokenApi: BearerTokenApi;
    private _router: Router;
    private _pathThatDoNotForwardToLogin: string[] = ["/login", "/signUp"]

    constructor(userStore: UserStore, router: Router, bearerTokenApi: BearerTokenApi) {
        this._userStore = userStore;
        this._router = router;
        this._bearerTokenApi = bearerTokenApi;
    }

    async getBearerToken(forceNewBearerToken:boolean = false): Promise<string | null> {

        // if we don't have a bearer token get one
        let bearerToken = this._userStore.getBearerToken();

        if (!bearerToken || forceNewBearerToken) {
            const bearerTokenResult = await this.requestBearerToken();
            
            if (bearerTokenResult.hasErrors()) {
                // cannot get bearer token, tell user to login again
                this._userStore.setBearerToken(null)
                return null;
            }

            this._userStore.setBearerToken(bearerTokenResult.value)
            bearerToken = bearerTokenResult.value;
        }
        
        return bearerToken;
    }

    private async requestBearerToken() {

        try {

            let response = await this._bearerTokenApi.post(
                {
                    "createBearerTokenFromRefreshTokenCookie": {
                        // intentionally blank
                    }
                },
                null,
                false,
                true
            );

            if (response.status === 200) {
                return Result.createSuccess(response.data.bearerToken);
            }

            return Result.createError(
                [
                    new ValidationError(
                        UuidHelper.newId(),
                        'Bearer token could not be acquired.',
                        'BearerTokenManager.CouldNotAcquireBearerToken'
                    )
                ]);

        } catch (e) {

            console.log('Could not acquire bearer token.');

            return Result.createError(
                [
                    new ValidationError(
                        UuidHelper.newId(),
                        'Bearer token could not be acquired.',
                        'BearerTokenManager.CouldNotAcquireBearerTokenDueToException'
                    )
                ]
            );

        }

    }

}